import React from 'react'
import { useSelector } from 'react-redux'
import { getGlobalProps } from 'state-management/selectors'
import Moment from 'react-moment';

export default function DateTime({ datetime, format }) {
    const globalProps = useSelector(getGlobalProps)
    return (
        <>
            {datetime && <Moment tz={globalProps.timezone} format={format}>{datetime}</Moment>}
        </>
    );
}







